import { TabNavLink } from './TabNavLink';

export default TabNavLink;
